import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { WaitListItemReplaceAppoinmentRequest, WaitListItemSearchRowViewModel, WaitListItemSetNotActiveRequest } from '../models/wait-list-items';

@Injectable({
  providedIn: 'root'
})
export class WaitListDataService {
    
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getWaitlistItemsForAppointment(appointmentId: number, timeout: Promise<any>): Promise<WaitListItemSearchRowViewModel[]> {
    return this.httpClient.getJsonAsync<WaitListItemSearchRowViewModel[]>('WaitListItems/GetWaitlistItemsForAppointment', {appointmentId}, timeout);
  }
  
  public replaceAppointment(appointmentId: number, waitListItemId: number, timeout: Promise<any>): Promise<any> {
    const request: WaitListItemReplaceAppoinmentRequest = { appointmentId, waitListItemId };

    return this.httpClient.postJsonAsync<any>('WaitListItems/ReplaceAppointment', request, timeout);
  }

  public setNotActiveWaitListItems(waitListItemIds: number[],  timeout: Promise<any> ): Promise<any> {
    const request: WaitListItemSetNotActiveRequest = { waitListItemIds };

    return this.httpClient.postJsonAsync<any>('WaitListItems/SetNotActiveWaitListItems', request, timeout);
  }
}
